import { render } from "./PaymentWalletAction.vue?vue&type=template&id=634951fe&scoped=true"
import script from "./PaymentWalletAction.vue?vue&type=script&lang=js"
export * from "./PaymentWalletAction.vue?vue&type=script&lang=js"

import "./PaymentWalletAction.vue?vue&type=style&index=0&id=634951fe&lang=scss&scoped=true"

import exportComponent from "/home/viapanelqualisof/admin.exchange.qualisoft.biz/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634951fe"]])

export default __exports__